import React from "react";
import "./ButtonCotizarMobile.css";

const ButtonCotizarMobile = (props) => {

    return (
        <React.Fragment>
            <button
                className="btn-cotizar-mobile font-face-encode-sans-light"
                onClick={props.onCotizarClicked}
                type={props.type}
            >
                Cotizar
            </button>
        </React.Fragment>
    );
};

export default ButtonCotizarMobile;
